/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-gov-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "codAPI",
            "endpoint": "https://78mg0epard.execute-api.us-gov-west-1.amazonaws.com/prod",
            "region": "us-gov-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-gov-west-1:d7c8e002-d9c5-4918-a357-efc6a598cd2c",
    "aws_cognito_region": "us-gov-west-1",
    "aws_user_pools_id": "us-gov-west-1_j2ixtr4f9",
    "aws_user_pools_web_client_id": "5vvk8cq1ejelch6bvjmpkg8ns4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "consentondemand-hosting-prod",
    "aws_content_delivery_bucket_region": "us-gov-west-1",
    "aws_content_delivery_url": "https://d2ic2w4jg9lxsj.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-gov-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "codAccount-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codAttestationLog-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codAttestationRequest-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codEmailTemplate-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codPerson-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codPostalCode-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codPrefillAttestation-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codTextTemplate-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codUser-prod",
            "region": "us-gov-west-1"
        },
        {
            "tableName": "codUserInvite-prod",
            "region": "us-gov-west-1"
        }
    ]
};


export default awsmobile;

